<template>
    <footer class="footer">
        <Container>
            <div class="flex wrap spbetween">
                <div class="cell">
                    <div class="title">制作单位</div>
                    <div class="msg">
                        <div>中国篮球协会</div>
                        <div>根尖体育科技（北京）有限公司</div>
                    </div>
                </div>
                <div class="cell">
                    <div class="title">联系我们</div>
                    <div class="msg">
                        <div>办公地址：北京市海淀区海淀大街中关村E世界C座863室</div>
                        <div>合作电话：1861 - 2884 - 418</div>
                        <div>合作邮箱：service@rootsports.cn</div>
                    </div>
                </div>
                <div class="imgs">
                    <div class="col">
                        <div class="name">中国篮协公众号</div>
                        <img src="assets/lanxiegzh.png" alt="中国篮协公众号" />
                    </div>
                    <div class="col">
                        <div class="name">根尖体育公众号</div>
                        <img src="assets/qiujigzh.png" alt="根尖体育公众号" />
                    </div>
                </div>
            </div>
            <div class="auth flex wrap spread">
                <div>根尖体育科技（北京）有限公司</div>
                <!-- <div>京ICP备15028441号-2</div> -->
                <!-- <div>营业执照</div> -->
            </div>
        </Container>
    </footer>
</template>

<script lang="ts" setup></script>

<style scoped lang="less">
.footer {
    width: 100%;
    box-sizing: border-box;
    background-color: @dark-color;
    color: #d8d8d8;
    padding: 30px 10px;
    .cell {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        .title {
            font-weight: 600;
            margin-bottom: 20px;
        }
    }
    .imgs {
        display: flex;
        .col {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            margin-left: 10px;
            .name {
                margin-bottom: 20px;
            }
            img {
                width: 100px;
            }
        }
    }
    .auth {
        margin-top: 20px;
    }
}
</style>
